import React from 'react';

export default ({
  count, title,
  width, height,
  color, size, fontWeight,
  padding, bgColor,
}) => {
    return(
      <div  style={{
        width: width ? width : 110 , 
        height: height ? height : 36,
        padding: padding ? padding : 0,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: bgColor || '#F4F7FD',
        borderRadius: 8
        }}>
          <div>
             <span style={{color: color, fontSize: size, fontWeight: fontWeight }}>{title}</span>
          </div>
          <div style={{marginLeft: 5}}>
             <span style={{color: color, fontSize: size,fontWeight: fontWeight }}>{count}</span>
          </div>
      </div>
    )
}